/**
 * Composable for managing icon size and styling
 * Extracted from Icon.vue to enable reuse across icon components
 */
import { computed } from 'vue'

export function useIconSize(props) {
  const spanClass = computed(() => {
    const base = [
      props.class ?? '',
      'inline-flex',
      'justify-center',
      'items-center',
      props.w ?? 'w-6',
      props.h ?? 'h-6'
    ]

    if (props.updateMark) {
      base.push('relative')
    }

    return base
  })

  const svgSize = computed(() => {
    return props.size ?? 16
  })

  return {
    spanClass,
    svgSize
  }
}
